import { Component, OnInit } from '@angular/core';
import { BibliographyService } from '../../../services/bibliography.service';
/* VocTermByIdPipe needed by ...*/
// import { VocTermByIdPipe } from '../../../pipes/voc-term-by-id.pipe';

@Component({
    selector: 'app-section-bibliography',
    templateUrl: './section-bibliography.component.html',
    styleUrls: ['./section-bibliography.component.css'],
    providers: [
        BibliographyService
        // VocTermByIdPipe
    ]
})
export class SectionBibliographyComponent {

}



// WEBPACK FOOTER //
// ./src/app/components/sections/section-bibliography/section-bibliography.component.ts